module.exports = __webpack_public_path__ + "img/id5.7129b07d.png";